import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import { compose } from 'recompose'
import Paper from 'material-ui/Paper'
import muiThemeable from 'material-ui/styles/muiThemeable'
import CmsApis from 'apis/cmsApis'
import withIntl from 'store/intl/withIntl'
import withStoreLocator from 'store/storeLocator/withStoreLocator'
import { withStoreLocatorPreferences } from 'store/preferences/withPreferences'
import withEditPage from 'hocs/extends/withEditPage'
import StateToolBar from 'components/bars/StateToolBar'
import StoreList from './stores/StoreList'

const StoreListManager = compose(
  withStoreLocator(),
  withEditPage({
    resourceName: 'storeLocator',
    getFetchAction: () => CmsApis.getStoreLocator,
    getUpdateAction: () => CmsApis.updateStoreLocator,
    getInitialResource: (props) => props.storeLocator,
    getInitialState: (props) => props.storeLocator,
    fetchPredicate: ({ storeLocator }) => !storeLocator || isEmpty(storeLocator),
    getOnFetchSuccess: ({ fetchStoreLocatorSuccess }) => (
      (resource) => fetchStoreLocatorSuccess(resource)
    ),
    getOnUpdateSuccess: ({ updateStoreLocatorSuccess }) => (
      (resource) => updateStoreLocatorSuccess(resource)
    ),
  }),
  withIntl(),
  muiThemeable(),
  withStoreLocatorPreferences(),
)(
  ({
    onChange,
    onSave,
    saveStatus,
    isStateChanged,
    setIsStateChanged,
    onDiscardChange,
    currentLang,
    storeLocator,
    storeLocator: {
      stores: {
        collections: storeCollections = [],
      } = {},
      stores,
    } = {},
  }) => {
    return (
      <Paper>
        <StateToolBar
          primary={isStateChanged}
          isStateChanged={isStateChanged}
          onDiscard={() => {
            setIsStateChanged(false)
            return onDiscardChange()
          }}
          onSave={onSave}
          saveStatus={saveStatus}
        />
        <StoreList
          stores={storeCollections}
          currentLang={currentLang}
          onChange={
            (value) => {
              onChange({
                ...storeLocator,
                stores: {
                  ...stores,
                  collections: value,
                },
              })
              setIsStateChanged(true)
            }
          }
        />
      </Paper>
    )
  }
)

StoreListManager.propTypes = {}
StoreListManager.defaultProps = {}

export default StoreListManager



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/StoreListManager.js